import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderProvider } from '../providers/order.provider';
import { OrderClientInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface RememberOrderUseCaseParams {
    product: SelectedProductInterface;
    client: OrderClientInterface;
}

@Injectable()
export class RememberOrderUseCase implements UseCaseWithParam<RememberOrderUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: RememberOrderUseCaseParams): Observable<Transaction<boolean>> {
        return this.orderProvider.remember(params.product, params.client.clientCode);
    }
}
